import { cartDetailsFragment } from '../queries/get-cart-query'

const cartLinesRemoveMutation = /* GraphQL */ `
  mutation checkoutLineItemRemove($cartId: ID!, $lineIds: [ID!]!) {
    cartLinesRemove(cartId: $cartId, lineIds: $lineIds) {
      userErrors {
        code
        field
        message
      }
      cart {
        ...cartDetails
      }
    }
  }
  
  ${cartDetailsFragment}
`
export default cartLinesRemoveMutation
